import React from "react";

import {
  TokenMetadataAttribute,
  _CollectionType,
} from "apollo/graphql.generated";

import { GetManageTokenCollectionQuery } from "../../queries.graphql.generated";

import { ViewEditionMetadataModal } from "./ViewEditionMetadataModal";
import { ViewSeriesMetadataModal } from "./ViewSeriesMetadataModal";

export const ViewMetadataModal = ({
  isAuction,
  seriesTokens,
  name,
  description,
  attributes,
  onClose,
  mediaUrl,
  coverImageUrl,
  collectionType,
}: ViewMetadataModalProps) => {
  if (collectionType === _CollectionType.Series && seriesTokens) {
    return (
      <ViewSeriesMetadataModal
        seriesTokens={seriesTokens}
        isAuction={isAuction}
        onClose={onClose}
      />
    );
  } else if (collectionType !== _CollectionType.Series) {
    return (
      <ViewEditionMetadataModal
        mediaUrl={mediaUrl}
        coverImageUrl={coverImageUrl}
        name={name}
        description={description}
        attributes={attributes}
        onClose={onClose}
      />
    );
  } else {
    return <></>;
  }
};

// for edition view
export interface ViewMetadataModalProps {
  seriesTokens?: GetManageTokenCollectionQuery["getCollection"]["seriesTokens"];
  isAuction: boolean;
  collectionType: _CollectionType;
  name: string;
  description: string;
  seriesImageUrls?: string[];
  mediaUrl: string;
  coverImageUrl: string | null;
  onClose: () => void;
  attributes: TokenMetadataAttribute[];
}
